<script>
import videojs from 'video.js';
export default {
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options);
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<template>
  <div class="video-player-wrapper">
    <video class="video-js vjs-big-play-centered" ref="videoPlayer"></video>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.video-player-wrapper {
  display: block;
  margin-bottom: 2rem;
  width: 50%;

  .video-js {
    width: 100%;
  }
}
</style>
